import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<title>Account</title>
		<circle cx={12} cy={6} r={3.25} stroke="var(--svg-color, currentColor)" strokeWidth={1.5} />
		<path
			fill="var(--svg-color, currentColor)"
			fillRule="evenodd"
			d="M17.5 19H19a7 7 0 1 0-14 0h1.5a5.5 5.5 0 1 1 11 0Z"
			clipRule="evenodd"
		/>
	</svg>
);
export { SvgComponent as Account24 };
